import React from 'react'
import {
	IonText,
	IonButton,
	IonSpinner,
} from '@ionic/react'
import { Icon } from '@iconify/react'

const ProtocolBenefits = ({ protocol, onContinue, isLoading }) => {
	if (!protocol) {
		return (
			<div className="loading-container">
				<IonSpinner name="crescent" />
				<IonText>Caricamento...</IonText>
			</div>
		)
	}

	return (
		<div>
			<h1>{protocol.name}</h1>
			
			<div className="protocol-description">
				<div 
					dangerouslySetInnerHTML={{ __html: protocol.app_description }}
					className="html-content"
				/>
			</div>

			<div className="objectives-covered">
				<h3>Obiettivi coperti</h3>
				{protocol.matched_goals.map((goal, index) => (
					<div key={goal.id} className="goal-item">
						<Icon icon="mingcute:check-2-fill" width={20} height={20} color="#8bc34a" />
						<span className="goal-name">{goal.name}</span>
						{/* <span className="goal-impact">
							{index === 0 ? ' - Impatto principale' : ' - Beneficio secondario'}
						</span> */}
					</div>
				))}
			</div>

			<div className="expected-benefits">
				<h3>Benefici attesi</h3>
				<div 
					dangerouslySetInnerHTML={{ __html: protocol.app_benefits }}
					className="html-content benefits-list"
				/>
			</div>

			<div className="buttons">
				<IonButton
					shape="round"
					onClick={onContinue}
					disabled={isLoading}
					color="primary"
					expand="full"
				>
					{isLoading ? <IonSpinner name="crescent" /> : 'Attiva questo protocollo'}
				</IonButton>
			</div>
		</div>
	)
}

export default ProtocolBenefits
